/**
 * Verschiedene Formatierungen
 */
export class MitsPDFFormatter {
  regexpFullDate =
    '\\d{4}-[01]\\d-[0-3]\\dT[0-2]\\d:[0-5]\\d:[0-5]\\d\\.\\d+([+-][0-2]\\d:[0-5]\\d|Z)';

  /**
   * Prüft den Wert und entscheidet anhand von Kriterien wie er formatiert werden soll
   * @param {string|number|null|undefined} val
   * @return {string | number}
   */
  checkAndFormatValue(
    val: string | number | null | undefined
  ): string | number {
    const valAsString = val + '';

    if (valAsString.search(this.regexpFullDate) >= 0) {
      return this.formatAsDate(valAsString);
    } else if (val == null) {
      return '';
    } else {
      return val;
    }
  }

  /**
   * Wert als Datum formatieren
   * @param {string} val
   * @return {string}
   */
  private formatAsDate(val: string): string {
    const d = new Date(val);
    return (
      this.fillString(d.getDate(), '0', 2) +
      '.' +
      this.fillString(d.getMonth(), '0', 2) +
      '.' +
      d.getFullYear()
    );
  }

  private fillString(
    str: string | number,
    filler: string,
    length: number
  ): string {
    let newStr = '';
    str = str.toString();
    for (let i = 0; i < length - str.length; i++) {
      newStr += filler.substring(0, 1);
    }
    return newStr + str;
  }
}
